import { DEFAULT_WEEK_DAYS } from './data'
import { PickPointFileItemType, PickPointFileType, PickPointVideoItemType, Timetable, TimetableDays } from './types'

export function getMedia(actualUrls: string): {
  videos: PickPointVideoItemType[]
  photos: PickPointFileItemType[]
  documents: PickPointFileItemType[]
} {
  const hasActualUrls = actualUrls?.trim().length > 0

  const photos: PickPointFileItemType[] = []
  const videos: PickPointVideoItemType[] = []
  const documents: PickPointFileItemType[] = []

  if (hasActualUrls) {
    const parsed = JSON.parse(actualUrls) as (PickPointFileItemType & PickPointVideoItemType)[]

    for (const item of parsed) {
      const isDocument =
        item.type === PickPointFileType.leaseDocument ||
        item.type === PickPointFileType.btiDocument ||
        item.type === PickPointFileType.btiDocumentEditArea ||
        item.type === PickPointFileType.leaseDocumentEditArea

      if (item.type === PickPointFileType.video) {
        videos.push(item)
      } else if (isDocument) {
        documents.push(item)
      } else {
        photos.push(item)
      }
    }
  }

  return { videos, photos, documents }
}

export const getActualUrls = (
  photos: PickPointFileItemType[],
  videos: PickPointVideoItemType[],
  documents: PickPointFileItemType[],
) => {
  if (!videos && !photos) {
    return null
  }

  const reqVideos = videos ? videos.filter((video) => video?.url) : []
  const reqPhotos = photos || []
  const reqDocuments = documents || []

  return JSON.stringify(
    reqPhotos
      .map((value) => ({ isPublic: value.isPublic, type: value.type, url: value.url }))
      .concat(reqVideos.map((value) => ({ isPublic: false, type: PickPointFileType.video, url: value.url })))
      .concat(reqDocuments.map((value) => ({ isPublic: false, type: value.type, url: value.url }))),
  )
}

export const getTimetableModel = (timetable: string) => {
  const openClose = { open: '', close: '' }

  const days: TimetableDays = {}

  for (const day of DEFAULT_WEEK_DAYS) {
    days[day.value] = { ...openClose, is_day_off: day.isDayOff }
  }

  const defaultTimeTable: Timetable = {
    daily: openClose,
    sat: openClose,
    sun: openClose,
    week: {
      days,
    },
  }

  try {
    const res = JSON.parse(timetable) as Timetable | undefined
    return res ?? defaultTimeTable
  } catch (error) {
    return defaultTimeTable
  }
}
